import { render, staticRenderFns } from "./chat-video-viewer.vue?vue&type=template&id=48452540&scoped=true"
import script from "./chat-video-viewer.vue?vue&type=script&lang=js"
export * from "./chat-video-viewer.vue?vue&type=script&lang=js"
import style0 from "./chat-video-viewer.vue?vue&type=style&index=0&id=48452540&prod&lang=less&scoped=true"
import style1 from "./chat-video-viewer.vue?vue&type=style&index=1&id=48452540&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48452540",
  null
  
)

export default component.exports